import { TemplateContext } from '../../../../models/reportTemplate.model';
import { SegProfile } from '../../../../services/template-mappers/entities/risk-register-seg-group.model';
import { SEG_STYLES } from './seg-profile-presentation.service';

/**
 * Shared template context for every SEG-profile widget config.
 * Declared once here (rather than copy-pasted per widget) so a change to the
 * `computedData.segProfiles` shape only needs updating in one place.
 */
export interface SegProfileContext extends TemplateContext {
    computedData?: { segProfiles?: SegProfile[] } & Record<string, unknown>;
}

/** `<th>` cell for a SEG widget PDF loop template. */
export const segTh = (label: string): string =>
    `<th style="${SEG_STYLES.headerCell}">${label}</th>`;

/** `<td>` cell binding a placeholder property for a SEG widget PDF loop template. */
export const segTd = (prop: string): string =>
    `<td style="${SEG_STYLES.cell}">[[this.${prop}]]</td>`;

/**
 * Definition-list item for the SEG header widget PDF loop template.
 * When `guardProp` is supplied the item is wrapped in a `data-tpl-if` so the
 * engine omits it entirely when that data field is empty (avoids rendering an
 * empty "Label:" chip in the generated PDF).
 */
export const segDefItem = (label: string, prop: string, guardProp?: string): string => {
    const guard = guardProp ? ` data-tpl-if="this.${guardProp}"` : '';
    return `<span${guard} style="${SEG_STYLES.defItem}"><span style="${SEG_STYLES.defLabel}">${label}:</span><span>[[this.${prop}]]</span></span>`;
};
